// ============================================================================
// UKRAINIAN TRANSLATIONS - CHAPTER 3: ІСУС ХРИСТОС
// ============================================================================
// Рівні 27-39 (13 рівнів, 39 питань)

export const chapter3Translations = {
  name: 'Ісус Христос',
  description: 'Слово стало тілом... Знати Христа - це вічне життя',
  
  spiritualWisdom: {
    principle: 'Знати Ісуса Христа - це вічне життя',
    scripture: 'А життя вічне в тому, щоб знали Тебе, єдиного істинного Бога, і посланого Тобою Ісуса Христа (Івана 17:3)',
    application: 'Кожен аспект життя Ісуса відкриває Бога і живить нашу душу для вічності'
  },
  
  levels: {
    27: {
      name: 'Благовіщення',
      challenge: 'Ангел Гавриїл був посланий Богом до міста Галілейського...',
      easy: {
        question: 'Який ангел сповістив Марії, що вона народить Ісуса?',
        options: ['Михаїл', 'Гавриїл', 'Рафаїл', 'Уріїл'],
        hint: 'Ангел-вісник Божий',
        funFact: '👼 Гавриїл означає Сила Божа - ангел великих благовістей!'
      },
      medium: {
        question: 'Якою була перша реакція Марії на цю звістку?',
        options: [
          'Негайна радість',
          'Повна недовіра',
          'Збентеження і питання Як це станеться?',
          'Страх'
        ],
        hint: 'Практичне і обґрунтоване питання',
        funFact: '🤔 Марія ставить логічне питання, але зберігає відкрите серце до Бога!'
      },
      hard: {
        question: 'Чого вчить нас покірність Марії волі Божій?',
        options: [
          'Пасивності перед випробуваннями',
          'Віри, яка довіряє, навіть не розуміючи всього',
          'Сліпої покори',
          'Змирення'
        ],
        hint: 'Йдеться про довіру Богу навіть у невідомому',
        funFact: '🙏 Нехай мені буде за словом твоїм - зразок довірливої віри!'
      }
    },
    
    28: {
      name: 'Різдво',
      challenge: 'І породила Сина свого Первородженого, і сповила Його, і поклала Його в яслах...',
      easy: {
        question: 'В якому місті народився Ісус?',
        options: ['Назарет', 'Єрусалим', 'Віфлеєм', 'Капернаум'],
        hint: 'Місто Давида',
        funFact: '🏘️ Віфлеєм означає Дім хліба - Ісус, хліб життя!'
      },
      medium: {
        question: 'Хто першим отримав звістку про народження?',
        options: [
          'Волхви',
          'Пастухи в полі',
          'Священики Храму',
          "Сім'я Марії"
        ],
        hint: 'Прості люди, що пасли стада',
        funFact: '🐑 Бог сповіщає спочатку смиренним пастухам - Євангеліє для всіх!'
      },
      hard: {
        question: 'Що символізує Ісус, народжений у яслах?',
        options: [
          'Бідність Його батьків',
          'Смирення Бога, що схиляється до нас',
          'Нестачу місця',
          'Сільську простоту'
        ],
        hint: 'Йдеться про божественне втілення в смиренні',
        funFact: '👶 Творець всесвіту народжується в хліві - безмежна любов!'
      }
    },

    29: {
      name: 'Волхви зі Сходу',
      challenge: 'Волхви зі сходу прийшли в Єрусалим і запитали...',
      easy: {
        question: 'Що привело волхвів до Ісуса?',
        options: ['Ангел', 'Зірка', 'Видіння', 'Карта'],
        hint: 'Небесне тіло',
        funFact: '⭐ Зірка представляє, що Ісус - світло народів!'
      },
      medium: {
        question: 'Які дари принесли волхви?',
        options: [
          'Їжу',
          'Золото, ладан і смирну',
          'Дорогі одежі',
          'Іграшки'
        ],
        hint: 'Три символічні й дорогоцінні дари',
        funFact: '🎁 Золото (царство), ладан (божественність), смирна (жертва) - уся місія Ісуса!'
      },
      hard: {
        question: 'Що представляють ці язичницькі волхви в Божому плані?',
        options: [
          'Перевагу інших релігій',
          'Всезагальність спасіння, пропонованого всім народам',
          'Матеріальне багатство',
          'Стародавню науку'
        ],
        hint: 'Йдеться про відкриття спасіння всім народам',
        funFact: '🌍 Волхви передбачають Євангеліє, яке досягне всього світу!'
      }
    },

    30: {
      name: 'Хрещення Ісуса',
      challenge: 'Христившись, Ісус зараз же вийшов з води...',
      easy: {
        question: 'Хто хрестив Ісуса?',
        options: ['Петро', 'Іван Хреститель', 'Андрій', 'Яків'],
        hint: 'Попередник Ісуса',
        funFact: '🌊 Іван Хреститель вважав себе негідним розв\'язати взуття Ісуса!'
      },
      medium: {
        question: 'Що зійшло на Ісуса при Його хрещенні?',
        options: [
          'Світло',
          'Голуб (Святий Дух)',
          'Ангел',
          'Тільки голос'
        ],
        hint: 'Птах - символ миру',
        funFact: '🕊️ Голуб відкриває божественне помазання для початку служіння!'
      },
      hard: {
        question: 'Чому безгрішний Ісус хрестився?',
        options: [
          'Щоб подати приклад',
          'Щоб виповнити всяку правду і ототожнитися з нами',
          'Через релігійний обов\'язок',
          'Щоб отримати прощення'
        ],
        hint: 'Йдеться про солідарність з грішним людством',
        funFact: '❤️ Ісус повністю ототожнюється з нами, щоб краще врятувати нас!'
      }
    },

    31: {
      name: 'Спокуса в Пустелі',
      challenge: 'Ісус був відведений Духом у пустелю для спокуси від диявола...',
      easy: {
        question: 'Скільки часу постив Ісус у пустелі?',
        options: ['30 днів', '40 днів', '50 днів', '60 днів'],
        hint: 'Біблійне число випробування',
        funFact: '🏜️ Як Мойсей та Ілля, 40 днів інтенсивної духовної підготовки!'
      },
      medium: {
        question: 'Як Ісус відкинув кожну спокусу?',
        options: [
          'Своєю силою',
          'Цитуючи Писання',
          'Ігноруючи сатану',
          'Тільки молитвою'
        ],
        hint: 'Духовна зброя par excellence',
        funFact: '📖 Написано... - Слово Боже, меч Духа!'
      },
      hard: {
        question: 'Чого вчить нас спокуса Ісуса про наші боротьби?',
        options: [
          'Спокуси - це гріх',
          'Спокуса може бути переможена Словом і вірою',
          'Треба тікати від кожної пустелі',
          'Тільки Ісус може встояти'
        ],
        hint: 'Йдеться про нашу стратегію проти спокус',
        funFact: '⚔️ Ісус показує нам, як перемагати: Слово Боже + активна віра!'
      }
    },

    32: {
      name: 'Перші Учні',
      challenge: 'Ісус сказав їм: Ідіть за Мною, і Я зроблю вас ловцями людей...',
      easy: {
        question: 'Якою була професія Петра і Андрія?',
        options: ['Пастухи', 'Рибалки', 'Теслярі', 'Митники'],
        hint: 'Професія на Галілейському озері',
        funFact: '🎣 Ісус перетворює рибалок риб на ловців душ!'
      },
      medium: {
        question: 'Як відреагували перші учні на поклик?',
        options: [
          'Довго вагалися',
          'Просили доказів',
          'Залишили все і зараз же пішли за Ним',
          'Торгувалися'
        ],
        hint: 'Негайна і повна відповідь',
        funFact: '🚶 Влада Ісуса була настільки очевидна, що вони покорилися миттєво!'
      },
      hard: {
        question: 'Що означає йти за Ісусом у наш час?',
        options: [
          'Залишити роботу',
          'Жити за Його вченням і волею',
          'Приєднатися до ізольованої спільноти',
          'Тільки проповідувати'
        ],
        hint: 'Йдеться про перетворення життя і пріоритетів',
        funFact: '✨ Йти за Ісусом перетворює наші серця, вибори, долю!'
      }
    },

    33: {
      name: 'Нагірна проповідь',
      challenge: 'Блаженні вбогі духом, бо їхнє Царство Небесне...',
      easy: {
        question: 'Яке перше блаженство в Нагірній проповіді?',
        options: [
          'Блаженні чисті серцем',
          'Блаженні вбогі духом',
          'Блаженні лагідні',
          'Блаженні миротворці'
        ],
        hint: 'Стосується духовної покори',
        funFact: '😊 Вбогі духом знають свою потребу в Богові - брама до Царства!'
      },
      medium: {
        question: 'Що сказав Ісус про миротворців?',
        options: [
          'Вони будуть щасливі',
          'Вони будуть названі синами Божими',
          'Вони будуть любимі',
          'Вони будуть сильні'
        ],
        hint: 'Особлива божественна ідентичність',
        funFact: '👑 Миротворці подібні до Бога - живе свідчення Його природи!'
      },
      hard: {
        question: 'Як блаженства перевертають цінності світу?',
        options: [
          'Засуджуючи багатство',
          'Ізолюючи віруючих',
          'Проголошуючи блаженними тих, кого світ зневажає',
          'Скасовуючи закони'
        ],
        hint: 'Йдеться про божественні цінності, протилежні світським',
        funFact: '🔄 Блаженства змінюють наше бачення щастя та успіху!'
      }
    },

    34: {
      name: 'Притчі про Царство',
      challenge: 'Він навчав їх притчами багато чого...',
      easy: {
        question: 'У притчі про сіяча, що представляє насіння?',
        options: [
          'Гроші',
          'Слово Боже',
          'Добрі справи',
          'Любов'
        ],
        hint: 'Те, що проповідує та навчає Ісус',
        funFact: '🌱 Слово Боже проростає і росте в наших серцях!'
      },
      medium: {
        question: 'У притчі про гірчичне зерно, що символізує це крихітне насіння?',
        options: [
          'Людську слабкість',
          'Царство, що починається малим, але стає великим',
          'Важливість деталей',
          'Природу'
        ],
        hint: 'Щось, що росте вражаючим чином',
        funFact: '🌳 З найменшого насіння виростає велике дерево - сила Царства!'
      },
      hard: {
        question: 'Чому Ісус навчав притчами?',
        options: [
          'Щоб ускладнити Своє послання',
          'Щоб відкрити духовні істини через знайомі образи',
          'Через брак часу',
          'Щоб перевірити інтелект'
        ],
        hint: 'Йдеться про те, щоб зробити таємниці Царства доступними',
        funFact: '💡 Притчі відкривають відкритим серцям і ховають від закритих!'
      }
    },

    35: {
      name: 'Чудеса Ісуса',
      challenge: 'Він вгамував бурю і сказав морю: Замовкни! Заспокойся!...',
      easy: {
        question: 'Скількома хлібами Ісус нагодував 5000 чоловік?',
        options: ['3 хліби', '5 хлібів', '7 хлібів', '12 хлібів'],
        hint: 'Стільки ж, скільки риб',
        funFact: '🍞 5 хлібів і 2 риби стають бенкетом - божественна щедрість!'
      },
      medium: {
        question: 'Що сказали учні, коли Ісус вгамував бурю?',
        options: [
          'Він чарівник',
          'Хто це, що й вітер і море слухаються Його?',
          'Це нормально',
          'Ми маємо піти звідси'
        ],
        hint: 'Питання про особу Ісуса',
        funFact: '⛈️ Навіть стихії визнають свого Творця і Господа!'
      },
      hard: {
        question: 'Яка головна мета чудес Ісуса?',
        options: [
          'Справити враження на натовп',
          'Явити Свою божественність і показати любов Бога',
          'Отримати вплив',
          'Допомогти лише матеріально'
        ],
        hint: 'Йдеться про божественне одкровення та співчуття',
        funFact: '❤️ Кожне чудо відкриває серце Бога: любов, співчуття, силу!'
      }
    },

    36: {
      name: 'Преображення',
      challenge: 'І преобразився перед ними; обличчя Його засяяло, як сонце...',
      easy: {
        question: 'Які учні бачили преображення Ісуса?',
        options: [
          'Всі дванадцять',
          'Петро, Яків і Іван',
          'Тільки Петро і Іван',
          'Жінки, що йшли за Ним'
        ],
        hint: 'Внутрішнє коло трьох',
        funFact: '⛰️ Петро, Яків і Іван: привілейовані свідки божественної слави!'
      },
      medium: {
        question: 'Які постаті Старого Завіту з\'явилися?',
        options: [
          'Авраам і Ісаак',
          'Давид і Соломон',
          'Мойсей і Ілля',
          'Адам і Ной'
        ],
        hint: 'Представник Закону і Пророків',
        funFact: '📜 Мойсей (Закон) і Ілля (Пророки) свідчать про Ісуса!'
      },
      hard: {
        question: 'Що це преображення відкриває про природу Ісуса?',
        options: [
          'Він великий пророк',
          'Його прихована божественність тимчасово відкривається',
          'Він керує світлом',
          'Він може змінювати зовнішність'
        ],
        hint: 'Йдеться про одкровення Його божественної природи',
        funFact: '✨ Божественна слава Ісуса сяє - передчуття Його воскресіння!'
      }
    },

    37: {
      name: 'Урочистий вхід',
      challenge: 'Осанна Сину Давидовому! Благословенний, Хто йде в ім\'я Господнє!...',
      easy: {
        question: 'На якій тварині Ісус в\'їхав до Єрусалиму?',
        options: ['Кінь', 'Осел', 'Верблюд', 'Пішки'],
        hint: 'Тварина, що символізує смирення і мир',
        funFact: '🐴 Осел символізує смиренного Царя, що йде з миром, а не на війну!'
      },
      medium: {
        question: 'Що кричав натовп, зустрічаючи Ісуса?',
        options: [
          'Хай живе Цар!',
          'Осанна! Благословенний, Хто йде в ім\'я Господнє!',
          'Слава Богу!',
          'Свобода!'
        ],
        hint: 'Вигук радості та благословення',
        funFact: '🌿 "Осанна" означає "спаси зараз" - заклик до божественного спасіння!'
      },
      hard: {
        question: 'Чому цей вхід "урочистий", але трагічний?',
        options: [
          'Було мало людей',
          'Натовп, що вітає Його, відкине Його через 5 днів',
          'Влада була відсутня',
          'Йшов дощ'
        ],
        hint: 'Йдеться про непостійність людського серця',
        funFact: '💔 Той самий натовп буде кричати "Розіпни Його!" через кілька днів!'
      }
    },

    38: {
      name: 'Таємна вечеря',
      challenge: 'Прийміть, їжте, це Тіло Моє, що за вас віддається...',
      easy: {
        question: 'Що Ісус зробив з ногами Своїх учнів?',
        options: [
          'Благословив їх',
          'Умив їх',
          'Помазав їх',
          'Поцілував їх'
        ],
        hint: 'Жест смирення та служіння',
        funFact: '🦶 Учитель стає слугою - революція любові та смирення!'
      },
      medium: {
        question: 'Що встановив Ісус на цій вечері?',
        options: [
          'Хрещення',
          'Євхаристію (Причастя)',
          'Молитву "Отче наш"',
          'Піст'
        ],
        hint: 'Таїнство з хлібом і вином',
        funFact: '🍞🍷 Хліб і вино стають вічними символами жертви та любові!'
      },
      hard: {
        question: 'Що означає "це творіть на Мою пам\'ять"?',
        options: [
          'Повторюйте цю вечерю',
          'Святкуйте Мою смерть і воскресіння, поки не прийду',
          'Пам\'ятайте Мої слова',
          'Любіть один одного'
        ],
        hint: 'Йдеться про живу і пророчу пам\'ять',
        funFact: '⏳ Кожне причастя звіщає смерть Господню, доки Він не прийде!'
      }
    },

    39: {
      name: 'Гетсиманія',
      challenge: 'Отче Мій! якщо можливо, нехай мине Мене ча ця...',
      easy: {
        question: 'Де молився Ісус перед арештом?',
        options: [
          'У храмі',
          'У Гетсиманському саду',
          'На Оливній горі',
          'У домі друзів'
        ],
        hint: 'Сад оливкових дерев',
        funFact: '🫒 Гетсиманія означає "оливний прес" - місце сильного тиску!'
      },
      medium: {
        question: 'Що робили учні, поки Ісус молився?',
        options: [
          'Молилися з Ним',
          'Спали',
          'Стояли на варті',
          'Пішли'
        ],
        hint: 'Не могли пильнувати навіть одну годину',
        funFact: '😴 Дух бадьорий, тіло ж немічне - людська слабкість!'
      },
      hard: {
        question: 'Що агонія Ісуса відкриває про Його природу?',
        options: [
          'Він був просто людиною',
          'Він був повністю людиною і повністю Богом',
          'Він сумнівався у Своїй місії',
          'Він був слабкий'
        ],
        hint: 'Йдеться про таємницю Втілення',
        funFact: '✝️ Ісус повністю несе людську муку, залишаючись вірним Богу!'
      }
    }
  }
};

export default chapter3Translations;
